(function($){
  $(document).ready(function() {

    $.datepicker.regional['fr'] = {
        closeText:       'Fermer',
        prevText:        'Précédent',
        nextText:        'Suivant',
        currentText:     'Courant',
        monthNames:      ['Janvier','Février','Mars','Avril','Mai','Juin', 'Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
        monthNamesShort: ['Jan','Fév','Mar','Avr','Mai','Jun', 'Jul','Aoû','Sep','Oct','Nov','Déc'],
        dayNames:        ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
        dayNamesShort:   ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
        dayNamesMin:     ['Di','Lu','Ma','Me','Je','Ve','Sa'],
        dateFormat:      'dd/mm/yy',
        firstDay: 1,
        isRTL: false
    };
    $.datepicker.setDefaults($.datepicker.regional['fr']);
    $.datepicker.setDefaults({
        showAnim: "slide",
        dateFormat: "dd/mm/yy",
        yearRange: "-22:+0",
        changeYear: true,
        onClose: function(){$(this).trigger("blur")}
    });
    $(".datepicker:not([readonly])").datepicker();

    $(".form-actions[data-sticky]").stickybits({
        useStickyClasses: true,
        verticalPosition: 'bottom'
    });

    $('[data-toggle="buttons"] input[type="radio"]').on('focus', function(){
        $(this).parent('label').toggleClass('focus');
    })

    $("body").on('change', ".fileinput", function(e){
        var $input   = $( this ),
            $label   = $input.next( '.filelabel' ),
            labelVal = $label.html();

        var fileName = '';
        if( e.target.value )
            fileName = e.target.value.split( '\\' ).pop();
        if( fileName )
            $label.html( fileName );
        else
            $label.html( labelVal );

        $input
              .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
              .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
    });
  })
})(jQuery);